export default __webpack_public_path__ + "static/media/league-card-bg.66ade3db.png";